import { addTelemetryDebug, isExperimentalFeatureEnabled } from '@datadog/browser-core';
import { startMutationObserver } from './mutationObserver';
import { initInputObserver } from './observers';
export var initShadowRootsController = function (configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            var _a = startMutationObserver(mutationCb, configuration, shadowRootsController, shadowRoot), stopMutationObserver = _a.stop, flush = _a.flush;
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var stopInputObserver = initInputObserver(inputCb, configuration.defaultPrivacyLevel, {
                target: shadowRoot,
                domEvents: ["change" /* CHANGE */],
            });
            controllerByShadowRoot.set(shadowRoot, {
                flush: flush,
                stop: function () {
                    stopMutationObserver();
                    stopInputObserver();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                addTelemetryDebug('no shadow root in map', {
                    shadowRoot: shadowRoot ? shadowRoot.nodeName : 'no node name',
                    childrenLength: shadowRoot ? shadowRoot.childElementCount : '-1',
                    controllerByShadowRootSize: controllerByShadowRoot.size,
                    html: shadowRoot && isExperimentalFeatureEnabled('shadow_dom_debug')
                        ? shadowRoot.innerHTML.substring(0, 2000)
                        : undefined,
                });
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
//# sourceMappingURL=shadowRootsController.js.map